<div class='pattern-diff-view-container full-height-flex'>
  <div class='diff-view-header'>
    <div class='remote'>
      Remote project @if (currentBranch$ | async) {
      <span>({{currentBranch$ | async}})</span>
    }
  </div>
  <div class='local'>
    Local project
    <mat-slide-toggle class="secondary-slide-toggle"
      labelPosition='before'
      [ngModel]='showOnlyDifferences$ | async' (ngModelChange)='rememberShowDifferencesView($event)'>
      <span class="diff-switch-label">Show differences only</span>
    </mat-slide-toggle>
  </div>
</div>
<div class='remaining-space-flex-content-wrapper'>
  <div class='remaining-space-flex-content'>
    <div class='pattern-diff'>
      @if (patternNameDiff$ | async) {
        <adm4-pattern-name-diff
          [patternNameDiff]='patternNameDiff$ | async'
          [showOnlyDifferences]='showOnlyDifferences$ | async'
          [currentUsername]='currentUsername'
        ></adm4-pattern-name-diff>
      }
      @if (patternLabelDiff$ | async) {
        <adm4-pattern-label-diff
          [patternLabelDiff]='patternLabelDiff$ | async'
          [showOnlyDifferences]='showOnlyDifferences$ | async'
          [currentUsername]='currentUsername'
        ></adm4-pattern-label-diff>
      }
      @if (patternLinkDiff$ | async) {
        <adm4-pattern-link-diff
          [patternLinkDiff]='patternLinkDiff$ | async'
          [showOnlyDifferences]='showOnlyDifferences$ | async'
          [currentUsername]='currentUsername'
        ></adm4-pattern-link-diff>
      }
      @for (simplePatternDiff of simplePatternDiffData$ | async; track simplePatternDiff) {
        <adm4-simple-pattern-field-diff
          [simplePatternFieldDiff]='simplePatternDiff'
          [showOnlyDifferences]='showOnlyDifferences$ | async'
          [currentUsername]='currentUsername'
        ></adm4-simple-pattern-field-diff>
      }
      @if (deploymentHostDiffData$ | async) {
        <adm4-deployment-host-diff
          [deploymentHostDiff]='deploymentHostDiffData$ | async'
          [showOnlyDifferences]='showOnlyDifferences$ | async'
          [currentUsername]='currentUsername'
        ></adm4-deployment-host-diff>
      }
      @for (propertyDiff of propertyDiffs$ | async; track propertyDiff) {
        <adm4-property-diff
          [propertyDiff]='propertyDiff' [variables]='variables$ | async'
          [projectKey]='projectKey$ | async'
          [showOnlyDifferences]='showOnlyDifferences$ | async'
          [currentUsername]='currentUsername'
        ></adm4-property-diff>
      }
      @if (patternNotesDiffData$ | async) {
        <adm4-pattern-notes-diff
          [patternNotesDiff]='patternNotesDiffData$ | async'
          [showOnlyDifferences]='showOnlyDifferences$ | async'
          [currentUsername]='currentUsername'
        ></adm4-pattern-notes-diff>
      }
      <div class='remaining-space-flex-content-wrapper'>
        <div class='remaining-space-flex-content dummy-space-taker'>
          <div class='remote full-height'></div>
          <div class='local full-height'></div>
        </div>
      </div>
      <!-- when pattern is deleted the local part of diff view is covered with this block -->
      @if (isDeletedPattern) {
        <div class='deleted-pattern-local-info'>
          <mat-icon class='deleted-pattern-icon'>delete_forever</mat-icon>
          <div>
            <span class='deleted-pattern-name'>{{changesetItem.name}}</span>
            is deleted
          </div>
        </div>
      }
    </div>
  </div>
</div>
</div>
